import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SiteRenderer from "@/components/SiteRenderer";

export default function PublicSite() {
  const { slug } = useParams();
  const [site, setSite] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    api.get(`/public/sites/${slug}`)
      .then((r) => { setSite(r.data); setStatus("ok"); })
      .catch(() => setStatus("notfound"));

    if (site?.seo?.title) document.title = site.seo.title;
  }, [slug]);

  useEffect(() => {
    if (site?.seo?.title) document.title = site.seo.title;
  }, [site]);

  if (status === "loading") return <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white/40 text-sm">Loading site…</div>;
  if (status === "notfound") return <div className="min-h-screen flex items-center justify-center bg-[#050505]"><div className="text-center"><div className="font-display text-3xl text-white">Site not found</div><div className="text-white/50 mt-2 text-sm">This site may have been unpublished.</div></div></div>;

  return (
    <div data-testid="public-site">
      <SiteRenderer site={site} />
      <div className="fixed bottom-3 right-3 text-[10px] font-mono text-white/40 hover:text-white/80 bg-black/40 backdrop-blur px-2 py-1 rounded-full border border-white/10">
        <a href="/" target="_blank" rel="noreferrer">Built with AlphaCore</a>
      </div>
    </div>
  );
}
